import Vue from "vue";
import VueRouter from "vue-router";
import Index from "./views/Index.vue";
import About from "./views/About.vue";
import Therapy from "./views/Therapy.vue";
import Practice from "./views/Practice.vue";
import Imprint from "./views/Imprint.vue";
import ContactView from "./views/ContactView.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "index",
		components: {
			default: Index,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
	{
		path: "/ueber-mich",
		name: "about",
		components: {
			default: About,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
	{
		path: "/therapie",
		name: "therapy",
		components: {
			default: Therapy,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
	{
		path: "/praxis",
		name: "practice",
		components: {
			default: Practice,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
	{
		path: "/kontakt",
		name: "contact",
		components: {
			default: ContactView,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
	{
		path: "/impressum",
		name: "imprint",
		components: {
			default: Imprint,
			header: MainNavbar,
			footer: MainFooter,
		},
		props: {
			header: { colorOnScroll: 400 },
			footer: { backgroundColor: "black" },
		},
	},
];

const router = new VueRouter({
	mode: "history",
	routes: routes,
});

//router.beforeEach((to, from, next) => {
    //const authenticatedUser = null;
    //const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    //if (requiresAuth && ! authenticatedUser) next('login')
    //else next();
//});

export default router;
